import AabTileButton from './AabTileButton';

customElements.define('aab-tile-button', AabTileButton);
